import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Operator } from "../models/Operator";

interface GetOperatorsOptions {
	assetId?: number;
	includeDisabled?: boolean;
	signal?: AbortSignal;
}

export const getOperators = async ({
	assetId,
	includeDisabled = false,
	signal,
}: GetOperatorsOptions = {}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "IncludeDisabled", value: includeDisabled },
	];

	if (assetId != null) {
		parameters.push({ name: "AssetId", value: assetId });
	}

	const resp = await apiService.callV2(
		"[MES].[GetOperators]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Operator[];
	} else {
		throw new Error(resp.message || "Error fetching operators");
	}
};
